import { dateFormat } from 'utils/date';

type DisclaimerProps = {
  lastUpdatedAt: string;
};

export default function Disclaimer({ lastUpdatedAt }: DisclaimerProps) {
  return (
    <div className="space-y-2 pb-2" id="disclaimer">
      <hr />
      <p className="text-sm font-bold">
        Last updated on {dateFormat(lastUpdatedAt)}
      </p>
      <p className="text-xs">
        The data on this page is provided by&nbsp;
        <a
          href="https://brighte.com.au/"
          target="_blank"
          rel="noreferrer"
          className="link-text"
        >
          Brighte
        </a>
        , ACT Government partner and loan provider for the Sustainable Household
        Scheme.
      </p>
    </div>
  );
}
